import React from "react";
import { useLocation } from "react-router-dom";
import StatCardScreen from "./dashbordScreens/statCardScreen";
import ImageCarousel from "./dashbordScreens/liveCreativesImageCarousel";
import ActiveScreens from "./dashbordScreens/active_screen";
import { useEffect } from "react";
import { useTopBar } from "../../../context/TopBarContext";

const Dashboard: React.FC = () => {
  const { setTitle, setShowBackButton, pushNavState } = useTopBar();
  const location = useLocation();

  useEffect(() => {
    const title = "Hi Hussain, Good morning";
    const showBack = false;

    setTitle(title);
    setShowBackButton(showBack);

    pushNavState({
      path: location.pathname,
      title,
      showBackButton: showBack,
    });
  }, []);

  return (
    <div className="flex-1 relative min-h-screen overflow-hidden gap">
      <div className="p-1 sm:p-3 md:p-2 lg:py-2 lg:pl-1 xl:py-3 xl:pl-2 2xl:py-3 2xl:pl-2 3xl:py-[26px] 3xl:pl-[20px] w-full">
        <StatCardScreen />
        <ImageCarousel />
        <ActiveScreens />
      </div>
    </div>
  );
};

export default Dashboard;
